import {HIDDEN} from '@acng/frontend-bounty/dom/attribute.js';
import {remove} from '@acng/frontend-bounty/dom/move.js';

import {createFrontendFeature} from '../../core/model/feature.js';
import {hasFeature} from 'acng/core/service/env.js';

/**
 * The name of the _pin_ feature.
 */
const name = 'pin';

/**
 * The basic _pin_ feature template.
 */
const feature = createFrontendFeature(name);
feature[HIDDEN] = !hasFeature(name);

/**
 * Remove the element if the _pin_ feature is hidden for the user.
 *
 * @param {Element} element
 */
const compile = (element) => {
  if (feature[HIDDEN]) {
    remove(element);
  }
};

export {name, feature, compile};
